import axios from "axios";

const TransactionService = function () {
  this.transactionController = "/Umbraco/Api/Transaction/";
};

TransactionService.prototype = {
  getCurrentCustomerBalanceInfomation: function () {
    return new Promise((resolve, reject) => {
      const res = axios({
        method: "get",
        url: `${this.transactionController}/GetCurrentCustomerBalanceInfomation`,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      resolve(res);
    });
  }
};

export { TransactionService };



// WEBPACK FOOTER //
// ./EcomCore/Models/Transaction/TransactionService.js